import classNames from "classnames";
import React from "react";
import { TransitionGroup } from "react-transition-group";
import { t } from "ttag";

import { strings } from "../../../localization";
import { MattressSizeOptions, SizeData } from "../constants";
import { useMattressSizeState } from "../hooks/useMattressSizeState";

import styles from "./MattressSize.module.scss";

export const MattressSelectorSize = (): React.JSX.Element => {
    const {
        onPrevSize,
        onNextSize,
        selectedSize,
        isNextDisabled,
        isPrevDisabled,
        sizeClass,
        width,
        height,
    } = useMattressSizeState();

    const isSplit = [
        MattressSizeOptions.SPLIT_KING,
        MattressSizeOptions.CAL_SPLIT_KING,
    ].includes(selectedSize);

    const currentSizeClasses = classNames({
        [styles.sizeSelector]: !isSplit,
        [sizeClass]: true,
        [styles.sizeBorder]: !isSplit,
    });

    const selectedSizeLabel =
        SizeData.find((item) => item.value === selectedSize)?.label ||
        selectedSize;

    return (
        <div className={styles.container}>
            <div className={styles.heading}>
                <h1>{strings.get("MATTRESS_SELECTOR_HEADING")}</h1>
                <p className={styles.description}>
                    {strings.get("MATTRESS_SELECTOR_DESCRIPTION")}
                </p>
                <p className={styles.instructions}>
                    {strings.get("MATTRESS_SELECTOR_INSTRUCTION")}
                </p>
            </div>
            <div className={styles.sizeSelectorContainer}>
                <button
                    className={styles.decrementButton}
                    onClick={onPrevSize}
                    disabled={isPrevDisabled}
                    aria-label={t`Previous size`}
                >
                    &ndash;
                </button>
                <TransitionGroup className={currentSizeClasses}>
                    {/* TODO(i18n): Consider if measurement units need localization for international markets (", inches) */}
                    <div className={styles.widthMeasurement}>
                        {width}
                        &quot;
                    </div>
                    {isSplit ? (
                        <>
                            <div
                                className="left"
                                aria-label={t`Left side of mattress`}
                            ></div>
                            <div
                                className="right"
                                aria-label={t`Right side of mattress`}
                            ></div>
                        </>
                    ) : (
                        <div aria-label={t`Mattress visualization`}></div>
                    )}
                    {/* TODO(i18n): Consider if measurement units need localization for international markets (", inches) */}
                    <div className={styles.heightMeasurement}>
                        {height}
                        &quot;
                    </div>
                </TransitionGroup>
                <button
                    className={styles.incrementButton}
                    onClick={onNextSize}
                    disabled={isNextDisabled}
                    aria-label={t`Next size`}
                >
                    +
                </button>
            </div>
            <div className={styles.sizeLabel}>{selectedSizeLabel}</div>
        </div>
    );
};
